import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';
import {
  initializeUserDatabase,
  normalizeUserDatabase,
} from './initializeUserDatabase';

export async function getUserDatabase(user) {
  if (!user?.uid) return null;

  const userRef = doc(db, 'users', user.uid);
  const userSnap = await getDoc(userRef);

  if (!userSnap.exists()) {
    return initializeUserDatabase(user);
  }

  const normalizedDatabase = normalizeUserDatabase(userSnap.data());
  await setDoc(userRef, normalizedDatabase, { merge: true });

  return normalizedDatabase;
}
